/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  DeleteApiV1ClassstudentClassstudentidChannelsChannelid204,
  DeleteApiV1ClassstudentClassstudentidChannelsChannelid400,
  DeleteApiV1ClassstudentClassstudentidChannelsChannelid401,
  DeleteApiV1ClassstudentClassstudentidChannelsChannelid404,
  DeleteApiV1ClassstudentClassstudentidChannelsChannelid500,
  DeleteApiV1ClassstudentClassstudentidChannelsChannelidMutationResponse,
  DeleteApiV1ClassstudentClassstudentidChannelsChannelidPathParams,
} from "../../types/classStudentChannelsController/DeleteApiV1ClassstudentClassstudentidChannelsChannelid.ts";

export const deleteApiV1ClassstudentClassstudentidChannelsChannelidPathParamsSchema =
  z.object({
    classStudentId: z.coerce.number().int(),
    channelId: z.coerce.number().int(),
  }) as unknown as ToZod<DeleteApiV1ClassstudentClassstudentidChannelsChannelidPathParams>;

/**
 * @description (No Content) Requisição não encontrou resultados.
 */
export const deleteApiV1ClassstudentClassstudentidChannelsChannelid204Schema =
  z.any() as unknown as ToZod<DeleteApiV1ClassstudentClassstudentidChannelsChannelid204>;

/**
 * @description (Bad Request) Requisição em formato incorreto ou com dados faltantes.
 */
export const deleteApiV1ClassstudentClassstudentidChannelsChannelid400Schema =
  z.any() as unknown as ToZod<DeleteApiV1ClassstudentClassstudentidChannelsChannelid400>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const deleteApiV1ClassstudentClassstudentidChannelsChannelid401Schema =
  z.any() as unknown as ToZod<DeleteApiV1ClassstudentClassstudentidChannelsChannelid401>;

/**
 * @description (Not Found) Registro não encontrado.
 */
export const deleteApiV1ClassstudentClassstudentidChannelsChannelid404Schema =
  z.any() as unknown as ToZod<DeleteApiV1ClassstudentClassstudentidChannelsChannelid404>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const deleteApiV1ClassstudentClassstudentidChannelsChannelid500Schema =
  z.any() as unknown as ToZod<DeleteApiV1ClassstudentClassstudentidChannelsChannelid500>;

export const deleteApiV1ClassstudentClassstudentidChannelsChannelidMutationResponseSchema =
  z.lazy(
    () => deleteApiV1ClassstudentClassstudentidChannelsChannelid204Schema,
  ) as unknown as ToZod<DeleteApiV1ClassstudentClassstudentidChannelsChannelidMutationResponse>;
